export function isDefinedAndNotEmpty(value) {
  return (value !== undefined && value !== null && value !== '');
} 